
function inferApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }
  const host = window.location?.hostname || 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? `http://${host}:3001` : 'https://api.agilepro.ai';
}

export class ShareGateway {
  constructor({ fetch, apiBase } = {}) {
    const fetchImpl = typeof fetch === 'function' ? fetch : (typeof window !== 'undefined' && typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
    if (!fetchImpl) {
      throw new Error('ShareGateway requires a fetch implementation');
    }
    this.fetch = fetchImpl;
    this.apiBase = typeof apiBase === 'string' && apiBase ? apiBase : inferApiBase();
  }

  async shareChat({ chatId, recipientEmails = [], includeFull = false } = {}) {
    if (!chatId) {
      throw new Error('shareChat requires chatId');
    }
    const payload = {
      chatId,
      recipientEmails: Array.isArray(recipientEmails) ? recipientEmails : [],
      includeFull: Boolean(includeFull),
    };

    const response = await this.fetch(`${this.apiBase}/api/shares`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response || !response.ok) {
      const status = response ? response.status : 'network-error';
      throw new Error(`ShareGateway.shareChat failed (${status})`);
    }

    return typeof response.json === 'function' ? response.json() : null;
  }

  async fetchInbox() {
    const response = await this.fetch(`${this.apiBase}/api/inbox/shared-prompts`, {
      credentials: 'include',
    });
    if (!response || !response.ok) {
      const status = response ? response.status : 'network-error';
      throw new Error(`ShareGateway.fetchInbox failed (${status})`);
    }
    return typeof response.json === 'function' ? response.json() : [];
  }

  async saveInboxItem(itemId, projectId) {
    if (!itemId) {
      throw new Error('saveInboxItem requires itemId');
    }
    const response = await this.fetch(`${this.apiBase}/api/inbox/${encodeURIComponent(itemId)}/save`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ projectId }),
    });
    if (!response || !response.ok) {
      const status = response ? response.status : 'network-error';
      throw new Error(`ShareGateway.saveInboxItem failed (${status})`);
    }
    return typeof response.json === 'function' ? response.json() : null;
  }

  async dismissInboxItem(itemId) {
    if (!itemId) {
      throw new Error('dismissInboxItem requires itemId');
    }
    const response = await this.fetch(`${this.apiBase}/api/inbox/${encodeURIComponent(itemId)}/dismiss`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!response || !response.ok) {
      const status = response ? response.status : 'network-error';
      throw new Error(`ShareGateway.dismissInboxItem failed (${status})`);
    }
    return typeof response.json === 'function' ? response.json() : null;
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.ShareGateway = ShareGateway;
}
